import React from 'react';
import { useSelector } from 'react-redux';

import type { AppState } from 'redux-store';
import type { NotificationProps } from 'redux-store/slices/notifications/types';

import { Notifications } from './index';

export const NotificationContainer: React.FC = () => {
  const notifications = useSelector<AppState, NotificationProps[]>(state =>
    Object.values(state.notifications.hash),
  );

  return <Notifications notifications={notifications} />;
};
